
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cerca",
      function () {
        return require("private-next-pages/cerca.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cerca"])
      });
    }
  